const baseUrl = `${process.env.PUBLIC_URL}`;

export const RequestManager = {
  get: async (url: string): Promise<Response> => {
    const res = await fetch(`${baseUrl}${url}`);
    return res;
  },
};
